
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import Edit from '../../moreCore/UI/Edit/Edit';
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { MainCatalogTypes, MainCatalogs_Classes, MainCatalogs_ExternalEvents } from "../_loadingHelpers/MainCatalogTypes";
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import { ToasterHelpers } from "../../more/Helpers";
class MainCatalogsEditorBaseV2 extends compose(_StatefulSection, _TabEnabledMixin) {
    protected isStandAloneEdit: boolean = false;

    protected errorContainer: HTMLElement;
    protected errorMessage: HTMLElement;

    protected privilegeName_Delete: string = "MainCatalogsEditor__Delete";

    
    //protected allowNewEntityOnly: boolean = false;

    protected timeoutHandle: number = null;

    protected editMainContainer: HTMLElement;
    protected editFormHeader: HTMLElement;
    protected closeButton: HTMLButtonElement;
    protected saveButton: HTMLButtonElement;
    protected editFormLeftSection: HTMLElement;
    protected editFormRightSection: HTMLElement;

    protected isNew: boolean = true;
    
    protected entityId: string = null;
    protected entityClass: MainCatalogs_Classes = null;
    protected labelAttribute: string = "$Displayname";

    protected setHeading(title: string) {
        if (title) {
            if (this.editFormHeader) {
                this.UiModder.domAttr.set(this.editFormHeader, "innerHTML", title);
                this.hideNode(this.editFormHeader, false);

            } else {
                this.editFormHeader = this.UiModder.domConstruct.create("h4", {
                    "innerHTML": title
                }, this.domNode, "first");
            }

        } else {
            if (this.editFormHeader) {
                this.hideNode(this.editFormHeader);
            }
        }
    }

    public updateHeading(data?: string) {
        var newHeading;
        if (typeof (data) === "string") {
            newHeading = data;
        } else {
            newHeading = this.currentData[this.labelAttribute];
        }
        
        this.setHeading(newHeading);
        this.updateTabTitle(newHeading);
    }

    updateTabTitle(newTitle: string) {
        if (this.isEmbeddedInTab) {
            this.requestTabRename(newTitle);
        }
    }

    public setLabelAttribute(newLabelAttribute: string) {
        this.labelAttribute = newLabelAttribute;
    }

    protected loadEntityData<T>(className: string, entityId: string): void {
        if (!entityId) return;

        console.log("load entity")

        this.setStartupState("loading");

        let callBackFunction = "Webtool_API__MainCatalogsEditor_LoadEntityData";
        this.RequestManager.callfunction(
            callBackFunction,
            {
                className: className,
                entityId: entityId
            },
            lang.hitch(this, this._onLoadCatalogEntityDataResponse),
            lang.hitch(this, this._onLoadCatalogEntityDataError),
            false // sync
        );
        this.entityId = entityId;
    }

    private _onLoadCatalogEntityDataResponse(response: any): void {
        this.StandbyStop();
        console.debug(this.id + " loaded", response);
        this.setIsNew(false);

        this.setData(response);
        this.updateHeading();

        this.disableNode(this.editFormLeftSection, false);
        this.disableNode(this.editFormRightSection, false);

    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.updateHeading();
        this._createDataDefaultButtons();
        this._activateButtons();
    }

    setIsNew(isNew: boolean): void {
        this.isNew = isNew;

        if (!isNew) {
            if (this.hasUserRole(this.privilegeName_Delete)) {
                this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this._onClickButtonDelete));
            }
        }
    }

    protected _onChanged(attribute: string, value: any) {


        if (attribute == this.labelAttribute) {
            this.updateHeading();
        }
    }

    private _enableDataButtons() {
        this.requestContextButtonEnable("save");
        this.requestContextButtonEnable("rollback");
    }

    private _disableDataButtons() {
        this.requestContextButtonDisable("save");
        this.requestContextButtonDisable("rollback");
    }


    _onLoadCatalogEntityDataError(err): void {

        
        this.StandbyStop();

        if (this.sourceData) this._activateButtons();

        this.disableNode(this.editFormLeftSection);
        this.disableNode(this.editFormRightSection);

        if (this.isStandAloneEdit) {
            this._showErrorMessage(err.Message);
            
        } else {
            this.emit("CatalogEntityData_Error", err.Message);
            this.emit("error", err.Message);
        }
    }

    private _onClickButtonRollback(evt?: MouseEvent): void {
        this.rollback();
    }

    private _onClickButtonReload(evt?: MouseEvent): void {
        this._deactivateButtons();

        this.loadEntity(this.entityId);
    }

    protected beforeSave() {

    }

    private _onClickButtonSave(evt?: MouseEvent): void {
        this.beforeSave();


        var jsonData: Object = {
                ID: this.entityId,
                changedData: this.changedData,
                isNew: this.isNew,
                className: this.entityClass
        }

        if (this.isValid()) {
            this._deactivateButtons();
            this.saveCatalogData(jsonData);
        } else {
            this.showToast(this.translate("MainCatalogsEditor_Error_InvalidData"), "fas fa-exclamation-triangle");
            this.StandbyStop();
        }
    }

    //protected saveCatalogData(jsonData: object)
    //{
    //    this.StandbyStart();

    //    let callfunction = "Webtool_API__MainCatalogsEditorV2_SaveCatalogEntityData";

    //    this.RequestManager.callfunction(
    //        callfunction,
    //        jsonData,
    //        lang.hitch(this, this._onSaveCatalogDataResponse),
    //        lang.hitch(this, this._onSaveCatalogDataError),
    //        false // sync
    //    );
    //}

    protected saveCatalogData(jsonData: object) {
        let requestUrl = window.appRoot + "MainCatalogsEditor/SaveCatalogEntityDataV2";


        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, this._onSaveCatalogDataResponse),
            lang.hitch(this, this._onSaveCatalogDataError),
            false // sync
        );
    }


    protected _onSaveCatalogDataResponse(response: any): void { 
        console.log(this.id + ": saved", response);
        this.StandbyStop();
        let id = response.entityId;

        this.loadEntity(id);

        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });


        this.emit("CatalogEntityData_Save", id);
    }



    private _onSaveCatalogDataError(err: more.requestErrorMessage): void {
        console.error(this.id + " _onSaveCatalogDataError", err);
        this._activateButtons();
        this.StandbyStop();

        //this.emit("CatalogEntityData_Error", err.Message);
        this._showErrorMessage( err.Message);
    }

    protected __delayDisableSaveButton(disable: boolean): void {
        if (this.timeoutHandle != null) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }

        this.timeoutHandle = setTimeout(lang.hitch(this, this.disableSaveButton, disable), 200);
    }

    protected disableSaveButton(disable: boolean): void {
        if (this.saveButton == null) {
            return; //@TODO: früher abbrechen wenn der dlg icht geöffnet wurde... dann ist kein close notwendig
        }
        if (disable) {

            this.UiModder.domClass.add(this.saveButton, "w3-disabled");
        } else {

            this.UiModder.domClass.remove(this.saveButton, "w3-disabled");
        }
    }



    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle"); 
    }

    onDirtyChange(): void {
        //this.__delayDisableSaveButton(!this.isDirty());
        if (this.isDirty()) {
            this._enableDataButtons();
        } else {
            this._disableDataButtons();
        }
    }

    protected fixNewLineInMultilineEdit(editInput: MdsLax<InstanceType<typeof Edit>>): void {

        let value: string = editInput.getValue();

        if (value) {

            value = value.replace(/[\r\n]/g, "\r\n");
        }

        editInput.setValue(value, true);
    }

    _onCloseRequest() {
        let hasChanged = this.isDirty() === true;

        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.closeTab();
        } else if (result == 0) { // cancel

        }
        else {
            this._onClickButtonSave();
            on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeTab))
        }
    }

    private _onClickButtonClose(evt: MouseEvent): void {
        this.close();
    }

    close(): void {
        this.emit("CatalogEntityData_Close");
    }

    //_onSaveCatalogDataResponse(response: any): void {
    //    // wird überschrieben in Child-Klassen
    //    alert("_onSaveCatalogDataResponse not set in child! " + this.id);
    //}
    isValid(): boolean {
        // wird überschrieben in Child-Klassen
        alert("isValid not set in child! " + this.id);

        return false;
    }

    //protected createNewEntity(onlyNew: boolean): void {
    //        this.entityId = null;

    //        this.allowNewEntityOnly = onlyNew;
    //        this.isStandAloneEdit = true;
    //        this.editFormHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_New"];        
    //}

    
    loadEntity(entityId: string): void {
        if (entityId) {

            this.StandbyStart();

            this.loadEntityData(this.entityClass, entityId);

        } else if (!this.entityClass) {
            console.log("Missing entity class");
        } 
        else {
            this.emit("CatalogEntityData_NoId");
            
        }
    }
    
    protected indicateErrorOnInput(element: HTMLElement | MdsLax<InstanceType<typeof _StatefulBase>>) {

       
    }

    protected _onClick_Inactive(evt) {

        this._deactivateButtons();

        let requestUrl = window.appRoot + "MainCatalogsEditor/SetEntityAsInactive";
        //this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null // TODO class, ID
            },
            lang.hitch(this, this._onSetEntityAsInactiveResponse),
            lang.hitch(this, this._onSetEntityAsInactiveError),
            false // sync
        );
    }

    protected _onSetEntityAsInactiveResponse(): void {

        this._activateButtons();

    }

    protected _onSetEntityAsInactiveError(err): void {
        this._activateButtons();
        alert(err.Message);
    }

    protected _onClick_Delete(evt) {
        
    }

    private _sendDeleteRequest() {

    }

    protected beforeDelete() {
        this._deactivateButtons();

        var callfunction = "Webtool_API__MainCatalogsEditorV2_DeleteCalatolEntityData"

        this.RequestManager.callfunction(
            callfunction,
            {
                className: this.entityClass,
                ID: this.entityId
            },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError),

        )
    }

    private _onClickButtonDelete() {
        this.beforeDelete();
    }

    private _onDeleteResponse(response) {
        if (this.isEmbeddedInTab) {
            this.closeTab();
        }
        this.emit("deleted", { ID: this.entityId });
    }

    private _onDeleteError(error) {
        this._activateButtons();
        this._showErrorMessage(error.Message);
    }

    protected _setEntityClass() {
        console.warn("Entity class not set in child");
        alert("_setEntityClass not set in child");
    }

    _onEmbedding(): void {
        if (this.isEmbeddedInTab) {
            if (this.hasUserRole("ADMIN")) {
                //this.createDefaultButton("delete", lang.hitch(this, this._onClick_Delete));
                this.createDefaultButton("deactivate", lang.hitch(this, this._onClick_Inactive));
            }
            this._createDefaultButtons();
        }
    }

    private _createDefaultButtons(): void {
        this.createDefaultButton("save", lang.hitch(this, this._onClickButtonSave), false);
    }

    private _deactivateButtons(): void {
        this.requestContextButtonDisable("save");
        this.requestContextButtonDisable("reload");
        this.requestContextButtonDisable("rollback");
        this.requestContextButtonDisable("delete");
    }

    private _activateButtons(): void {
        this.requestContextButtonEnable("reload");
        this.requestContextButtonEnable("delete");
        if (this.isDirty()) {
            this.requestContextButtonEnable("save");
            this.requestContextButtonEnable("rollback");
        }
    }

    private _createDataDefaultButtons(): void {
        this.createDefaultButton("rollback", lang.hitch(this, this._onClickButtonRollback), false);
        this.createDefaultButton("reload", lang.hitch(this, this._onClickButtonReload), true);

        //var reloadButtonConfig: Tabbing.ContextActionButtonRequest = {
        //    callback: lang.hitch(this, this._onClickButtonReload),
        //    label: this.translate("General_Label_Reload"),
        //    permanent: false,
        //    iconClass: "fas fa-sync",
        //    placement: "actionbar",
        //    name: "reload",
        //}

        //this.createContextButton(reloadButtonConfig);
    }

    externalEventHandler(event: MainCatalogs_ExternalEvents) {

        switch (event) {
            case MainCatalogs_ExternalEvents.Save:
                this.StandbyStart();
                this._onClickButtonSave();
                break;
            case MainCatalogs_ExternalEvents.Rollback:
                this._onClickButtonRollback();
                break;
            case MainCatalogs_ExternalEvents.Delete:
                this._onClickButtonDelete();
                break;
            default:
                this._showErrorMessage(`Wrong external event! **${event}** event not supported!`)
        }
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._setEntityClass();
    //    this.setStartupState("ready");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.resetDirty();

    }
}

export default mdsWidget(MainCatalogsEditorBaseV2);